export const GET_VENDOR_LOGOUT_REQUEST = "GET_VENDOR_LOGOUT_REQUEST";
export const GET_VENDOR_LOGOUT_SUCCESS = "GET_VENDOR_LOGOUT_SUCCESS";
export const VENDOR_SESSION_EXPIRED_REQUEST = "VENDOR_SESSION_EXPIRED_REQUEST";
